import { connect } from 'react-redux';
import type { RouteComponentProps } from 'react-router';

import type { UpdateCmsPageRequest, WCmsPageView } from '@zola/svc-web-api-ts-client';

import type { AppDispatch } from 'reducers/index';

import { updatePage, updatePageSilently } from 'actions/website/PageActions';
import { updatePreview } from 'actions/website/WebsitePreviewActions';

import { EditPageFormV2WithRouter } from './EditPageFormV2';

type PreviewType = {
  description: string;
  header_image_url: string;
  hidden: boolean;
  title: string;
};

export type EditPageV2OwnProps = {
  page: WCmsPageView;
  showPaperCrossSell?: boolean;
};

export type EditPageFormV2DispatchProps = {
  submitPage: (pageView: Omit<UpdateCmsPageRequest, 'wedding_account_id'>) => Promise<void>;
  submitPageSilently: (pageView: Omit<UpdateCmsPageRequest, 'wedding_account_id'>) => Promise<void>;
  updatePreview: (preview: PreviewType) => void;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type EditPageV2Props = RouteComponentProps<any, any> &
  EditPageV2OwnProps &
  EditPageFormV2DispatchProps;

const mapDispatchToProps = (dispatch: AppDispatch): EditPageFormV2DispatchProps => {
  return {
    submitPage: (pageView: Omit<UpdateCmsPageRequest, 'wedding_account_id'>) =>
      dispatch(updatePage(pageView)),
    submitPageSilently: (pageView: Omit<UpdateCmsPageRequest, 'wedding_account_id'>) =>
      dispatch(updatePageSilently(pageView)),
    updatePreview: (preview: PreviewType) => dispatch(updatePreview(preview)),
  };
};

export default connect(null, mapDispatchToProps)(EditPageFormV2WithRouter);
